module.exports = __webpack_public_path__ + "10d77b4704cd014f74c25b0ebba7cf3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map2_thin.jpg
// module id = 69
// module chunks = 2